<template>
  <ul class="exp-pagination">
    <li class="exp-pagination__item">
      <a
        :class="{ _disabled: isPrevDisabled }"
        @click="handlePageSelected(--selected)"
        >{{ prevSymbol }}</a
      >
    </li>
    <li
      v-for="(page, index) in pages"
      :key="index"
      class="exp-pagination__item"
    >
      <a
        :class="{ _active: isPageActive(page) }"
        @click="handlePageSelected(page)"
        >{{ page }}</a
      >
    </li>
    <li class="exp-pagination__item">
      <a
        :class="{ _disabled: isNextDisabled }"
        @click="handlePageSelected(++selected)"
      >
        {{ nextSymbol }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    page: {
      type: Number
    },
    pageCount: {
      type: Number,
      required: true
    },
    totalVisible: {
      type: Number,
      default: 5
    },
    start: {
      type: Number,
      default: 1
    },
    ellipsis: {
      type: String,
      default: "..."
    }
  },
  data() {
    return {
      prevSymbol: "<",
      nextSymbol: ">"
    };
  },
  computed: {
    selected: {
      get() {
        return this.page;
      },
      set(newValue) {
        this.$emit("change", newValue);
      }
    },
    pages() {
      if (this.totalVisible === 1) return [this.pageCount];
      if (this.pageCount <= this.totalVisible) {
        return this.createRange(this.pageCount, this.start);
      }
      const even = this.totalVisible % 2 === 0;
      const middle = even
        ? this.totalVisible / 2
        : Math.floor(this.totalVisible / 2);
      const left = even ? middle : middle + 1;
      const right = this.pageCount - middle;
      if (left - this.selected >= 0) {
        return [
          ...this.createRange(Math.max(1, this.totalVisible - 1), this.start),
          this.ellipsis,
          this.pageCount
        ];
      } else if (this.selected - right >= (even ? 1 : 0)) {
        const rangeLength = this.totalVisible - 1;
        const rangeStart = this.pageCount - rangeLength + this.start;
        return [
          this.start,
          this.ellipsis,
          ...this.createRange(rangeLength, rangeStart)
        ];
      } else {
        const rangeLength = Math.max(1, this.totalVisible - 3);
        const rangeStart =
          rangeLength === 1
            ? this.selected
            : this.selected - Math.ceil(rangeLength / 2) + this.start;
        return [
          this.start,
          this.ellipsis,
          ...this.createRange(rangeLength, rangeStart),
          this.ellipsis,
          this.pageCount
        ];
      }
    },

    isPrevDisabled() {
      return this.selected === 1;
    },
    isNextDisabled() {
      return this.selected === this.pageCount;
    }
  },
  methods: {
    isPageActive(page) {
      return page === this.selected;
    },
    handlePageSelected(page) {
      this.$nextTick(() => {
        if (this.selected === page || typeof page !== "number") return;
        this.selected = page;
      });
    },
    createRange(length, start = 0) {
      return Array.from({ length }, (v, k) => start + k);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.exp-pagination {
  display: flex;
  align-items: center;
  max-width: 100%;
  margin: auto auto 0;
  width: fit-content;
  list-style: none;
  border: 1px solid var(--gray-darker);
  padding: 0;
  border-radius: 2px;
  user-select: none;
  &__item {
    &:not(:last-child) {
      border-right: 1px solid var(--gray-darker);
    }
    & a {
      color: #009ee3;
      font-size: 14px;
      font-weight: 500;
      padding: 10px 20px;
      display: inline-block;
      cursor: pointer;
      @include respond-down(xs) {
        padding: 8px 15px;
        font-size: 12px;
      }
      &._active {
        color: #fff;
        background-color: #009ee3;
      }
      &._disabled {
        pointer-events: none;
      }
    }
  }
}
</style>
